export default __webpack_public_path__ + "static/media/extrinsic_logo_paths.2554bc44.svg";